<template>
    <v-layout class="my-4 border">
        <v-flex class="pa-2">
            <v-select
                class="ucFirst body-1 tz-dropdown"
                :aria-label="formattedAriaLabel(
                    metadata[`description${this.upperLocale}`],
                    required
                )"
                :label="formattedLabel(
                    metadata[`description${this.upperLocale}`],
                    required
                )"
                :value="value"
                :items="dropDownOptions"
                :outline="outline"
                :append-icon="appendIcon"
                :rules="[
                    !required || requiredField()
                ]"
                :data-meta-id="metadata.id"
                :id="metadata.name"
                @input="emitValue"
            />
        </v-flex>
    </v-layout>
</template>

<script>
import { inputHelpers } from '@/mixins/inputHelpers';
import { assign, map, upperFirst } from 'lodash';
import { mapGetters } from 'vuex';
import { formRules } from '@/mixins/form-rules';

export default {
    name: 'covid-screening-student-level',
    mixins: [formRules, inputHelpers],
    props: {
        metadata: { type: Object, required: true },
        outline: { type: Boolean, required: false, default: false },
        required: { type: Boolean, required: false, default: false },
        value: { type: String, required: false, default: '' },
        withIcon: { type: Boolean, required: false, default: false },
    },
    data() {
        return { };
    },
    computed: {
        ...mapGetters({
            upperLocale: 'upperLocale',
        }),

        appendIcon() {
            return this.withIcon ? '' : '';
        },
        dropDownOptions() {
            const options = this.$i18n.t('covidScreeningMetadataLang.covidScreeningStudentLevel.dropDown');
            return map(options, (option, key) => {
                return assign({},
                    { key: key },
                    { text: option },
                    { value: option }
                );
            });
        },
    },
    methods: {
        emitValue(value) {
            this.$emit('update:value', this.upperFirst(value));
        },

        /**
         * Lodash upperFirst method wrapper for template
         * @param string
         */
        upperFirst(string) {
            return upperFirst(string);
        },
    },
};
</script>

<style scoped>
.border::v-deep {
    border: 2px solid var(--v-primary-base)!important;
    border-radius: 4px!important;
}
</style>
